import React from 'react'
import style from './solo-chat-routes.module.css'
import ExpandIcon from '../../assets/svg/solo-chat/expand.svg'
import { useLocation } from 'react-router-dom'
import { ContentIcon } from '../../assets/app-modules/contentIcon'
import { NLUIcon } from '../../assets/app-modules/nluIcon'
import { EventsIcon } from '../../assets/app-modules/eventsIcon'
import { QNAIcon } from '../../assets/app-modules/qnaIcon'

type Props = {
  redirectTo: (path: string) => void
  chatType: "nlp" | "genai"
}

export const SoloChatRoutes = (props: Props) => {
  const { redirectTo } = props
  const [isOpen, setIsOpen] = React.useState(false)
  const location = useLocation();
  const isAIAgentsRoute = location.pathname.endsWith("/solo/ai-agents")

  return (
    <div className={style.soloChatRoutes}>
      {props.chatType !== 'genai' && <div className='w-full'>
        <button  data-open={isOpen} onClick={() => setIsOpen(!isOpen)}>
          <div style={{ display: 'flex', alignItems: 'center' }}><NLUIcon /></div>
          <div style={{width: '100%' , display: 'flex',alignItems: 'center', justifyContent: 'space-between'}}>
            <span>NLU</span>
            <img src={ExpandIcon} />
          </div>
        </button>
        {isOpen && (
          <div className={style.routes}>
            <button style={{ paddingTop: 0 }} onClick={() => redirectTo("solo/nlu/tokens")}>Tokens</button>
            <button onClick={() => redirectTo("solo/nlu/basic-nlp")}>Basic NLP</button>
          </div>
        )}
      </div>}
      <button onClick={() => redirectTo(`solo/${props.chatType === 'genai' ? 'events':'qna'}`)}>{props.chatType === 'genai' ? <><EventsIcon/> Events</>: <><QNAIcon></QNAIcon>QnA</>}</button>
      <button onClick={() => redirectTo("solo/content")}><ContentIcon></ContentIcon>Content</button>
      {/* {window?.env?.GENAI_URL &&  */}
      {/* <button data-ai-agents-route={isAIAgentsRoute} className={style.aiAgents} onClick={() => redirectTo("solo/ai-agents")}>AI Agents</button> */}
    </div>
  )
}
